var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{attrs:{"color":"primary","type":"flat"},nativeOn:{"click":function($event){return _vm.reloadPage($event)}}},[_c('font-awesome-icon',{staticClass:"fa-icon",attrs:{"icon":['fas', 'redo']}}),_vm._v("\n    Pagina herladen\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }